import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';
import { type PromocodeItemListResponseBody as SchemaPromocodeItemListResponseBody } from '../schemas/PromocodeItemListResponseBody';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Возвращает список промокодов группы с пагинацией
 * @tags PromocodeGroups
 * @summary Получение списка промокодов в группе
 */
export const PromocodeGroupPromocodeListContentType = '' as const;
export type PromocodeGroupPromocodeListRequest = void;
export type PromocodeGroupPromocodeListResponses = LinkCommonErrorResponses & {
    /**
     * @description Успешная операция
     */
    '200': {
        'application/json': SchemaPromocodeItemListResponseBody;
    };
    /**
     * @description Not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type PromocodeGroupPromocodeListResponseSuccess =
    PromocodeGroupPromocodeListResponses['200']['application/json'];
export type PromocodeGroupPromocodeListSearchParams = {
    page: number;
    per_page: number;
    sort_by?: 'code' | 'created_at' | 'usage_count';
    sort_order?: 'asc' | 'desc';
    search?: string;
};
export type PromocodeGroupPromocodeListPathParameters = {
    group_id: string;
};
export const PromocodeGroupPromocodeListUrl = '/promocode_groups/{group_id}/promocodes' as const;
export const PromocodeGroupPromocodeListMethod = 'GET' as const;
export const getPromocodeGroupPromocodeListUrl = (params: PromocodeGroupPromocodeListPathParameters) =>
    PromocodeGroupPromocodeListUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof PromocodeGroupPromocodeListPathParameters) => String(params[param])
    );
